export default "__VITE_ASSET__1fc55287__"